module.exports = __webpack_public_path__ + "static/media/trakto.9b6d94d5.svg";